module.exports = __webpack_public_path__ + "clock reviews.svg?ab5352c4f60689cec9c9c69203802296";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/clock reviews.svg
// module id = 14
// module chunks = 0